import axios from "axios";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { ProductEditSchema } from "../../../ValidationSchema";
import ReactSelect from "../../../Components/PortalSelect";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import SizeModal from "../Product/sizeModel";

const BuyerProductEdit = ({ colourStyles }) => {
  const Navigate = useNavigate();

  const [initialValues, setInitialValues] = useState({
    title: "",
    size: [],
    material_color: [],
    print_coverage: [],
    paper_gsm: [],
    product_tag: [],
    slug: "",
    category: "",
    description: "",
    date_time: "",
    burst_factor: [],
    no_of_ply: [],
    product_image: "",
    gallery_image_path: "",
    lamination: "",
    quantity: "",
    user_id: "",
  });

  const [categoryData, setCategoryData] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [extraFields, setExtraFields] = useState([
    { label: "", inputValue: "", values: [] },
  ]);
  const location = useLocation();

  const [sizeData, setSizeData] = useState([]);

  const [showSizeModal, setShowSizeModal] = useState(false);
  const [newSize, setNewSize] = useState({ width: "", length: "", height: "" });

  const handleSizeSubmit = () => {
    const formattedSize = `${newSize.height} x ${newSize.width}`;
    const updatedOptions = [
      ...sizeData,
      { value: formattedSize, label: formattedSize },
    ];
    setSizeData(updatedOptions); // You should define setSizeData using useState
    setShowSizeModal(false);
    setNewSize({ width: "", length: "", height: "" }); // Reset the form
  };

  const handleInputChange = (index, field, value) => {
    const updatedFields = [...extraFields];
    updatedFields[index][field] = value;
    setExtraFields(updatedFields);
  };

  const handleAddRow = () => {
    setExtraFields([...extraFields, { label: "", value: "", values: [] }]);
  };

  const handleRemoveRow = (index) => {
    const updatedFields = [...extraFields];
    updatedFields.splice(index, 1); // remove 1 item at the given index
    setExtraFields(updatedFields);
  };
  const handleAddValue = (e, index) => {
    e.preventDefault(); // ⛔ Prevent form submit
    const trimmed = extraFields[index].inputValue.trim();
    if (trimmed === "") return;

    const updatedFields = [...extraFields];
    updatedFields[index].values.push(trimmed);
    updatedFields[index].inputValue = ""; // clear input
    setExtraFields(updatedFields);
  };

  const handleRemoveValue = (rowIndex, valIndex) => {
    const updatedFields = [...extraFields];
    updatedFields[rowIndex].values.splice(valIndex, 1);
    setExtraFields(updatedFields);
  };

  const handleAddSize = (newOption) => {
    setSizeData((prev) => [...prev, newOption]);
  };

  useEffect(() => {
    // Product ID ko props ya route se lein
    const productId = location?.state?.item?.product_id; // y

    if (productId) {
      axios
        .get(
          `${process.env.REACT_APP_URL}/admin/product/edit-get?id=${productId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("Token")}`,
            },
          }
        )
        .then((res) => {
          const data = res.data.data;
          setInitialValues({
            title: location?.state?.item?.title || "",
            size:
              typeof location?.state?.item?.size === "string"
                ? location?.state?.item?.size
                    .split(",")
                    .map((item) => ({ value: item, label: item }))
                : location?.state?.item?.size || [],
            material_color: location?.state?.item?.material_color || [],
            print_coverage: location?.state?.item?.print_coverage || [],
            paper_gsm: location?.state?.item?.paper_gsm || [],
            product_tag: location?.state?.item?.product_tag || [],
            slug: location?.state?.item?.slug || "",
            category: location?.state?.item?.category || "",
            description: location?.state?.item?.description || "",
            date_time: location?.state?.item?.date_time || "",
            burst_factor: location?.state?.item?.burst_factor || [],
            no_of_ply: location?.state?.item?.no_of_ply || [],
            tags: location?.state?.item?.tags || "",
            product_image: "", // file upload field, blank rakhein
            gallery_image_path: "", // file upload field, blank rakhein
            lamination: location?.state?.item?.lamination || "",
            quantity: location?.state?.item?.quantity || "",
            product_image: location?.state?.item?.product_image || "", // must be just the filename
            user_id: location?.state?.item?.user_id,
          });
          // Agar extraFields bhi API se aate hain to setExtraFields bhi yahan karein
        })
        .catch((err) => {
          // error handle karein
        });
    }
  }, []);

  const CategoriesData = () => {
    axios
      .get(`${process.env.REACT_APP_URL}/admin/categories/get`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Token")}`,
        },
      })
      .then((res) => {
        setCategoryData(
          res?.data?.data?.docs.map((item) => {
            return {
              label: item?.name || "Untitled", // fallback if title is undefined
              value: item?.id,
            };
          })
        );
      })
      .catch((err) => {
        if (err.response.data.message === "Unauthorized!") {
          Navigate("/");
        }
      });
  };

  // const SizeData = () => {
  //   axios
  //     .get(`${process.env.REACT_APP_URL}/size`, {
  //       // headers: {
  //       //   Authorization: `Bearer ${localStorage.getItem("Token")}`,
  //       // },
  //     })
  //     .then((res) => {
  //       setSizeData(
  //         res?.data?.data?.map((item) => {
  //           return {
  //             label: item?.size || "Untitled", // fallback if title is undefined
  //             value: item?.size,
  //           };
  //         })
  //       );
  //     })
  //     .catch((err) => {
  //       if (err.response.data.message === "Unauthorized!") {
  //         Navigate("/");
  //       }
  //     });
  // };

  const SubCategoriesData = () => {
    axios
      .get(`${process.env.REACT_APP_URL}/admin/sub-categories/get`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Token")}`,
        },
      })
      .then((res) => {
        setSubCategoryData(
          res?.data?.data?.docs.map((item) => {
            return {
              label: item?.name || "Untitled", // fallback if title is undefined
              value: item?.id,
            };
          })
        );
      })
      .catch((err) => {
        if (err.response.data.message === "Unauthorized!") {
          Navigate("/");
        }
      });
  };

  const EditProduct = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: ProductEditSchema,

    onSubmit: (values, action) => {
      const formData = new FormData();
      formData.append("product_id", location?.state?.item?.product_id);
      formData.append("title", values.title);
      formData.append("size", values.size);
      formData.append("material_color", values.material_color);
      formData.append("print_coverage", values.print_coverage);
      formData.append("paper_gsm", values.paper_gsm);
      formData.append("burst_factor", values.burst_factor);
      formData.append("no_of_ply", values.no_of_ply);
      formData.append("product_tag", JSON.stringify(values.product_tag));
      formData.append("slug", values.slug);
      formData.append("category", values.category);
      formData.append("description", values.description);
      formData.append("lamination", values.lamination);
      formData.append("quantity", values.quantity);
      formData.append("product_image", values.product_image);
      formData.append("user_id", location?.state?.item?.user_id);
      formData.append(
        "gallery_image_path",
        JSON.stringify(values.gallery_image_path)
      );
      // Append extra fields
      extraFields.forEach((field) => {
        if (field.label && field.values.length > 0) {
          formData.append(
            `extra_fields[${field.label}]`,
            JSON.stringify(field.values)
          );
        }
      });
      // Convert FormData to a regular object for logging
      const formDataObject = {};
      formData.forEach((value, key) => {
        if (key.startsWith("extra_fields[")) {
          const fieldName = key.replace("extra_fields[", "").replace("]", "");
          formDataObject[fieldName] = JSON.parse(value);
        } else {
          formDataObject[key] = value;
        }
      });
      // Send the form data to the server
      action.resetForm();
      action.setSubmitting(false);

      axios
        .post(
          `${process.env.REACT_APP_URL}/admin/buyer-product-edit`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("Token")}`,
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            toast.success(`${res?.data?.message}`);
            Navigate(
              `/admin/buyer/product-list/${location?.state?.item?.user_id}`,
              { state: res.data.msg }
            );
          }
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            toast.error(err.response.data.msg || "An error occurred");
          }
          console.error("Error submitting form:", err);
        });
    },
  });

  useEffect(() => {
    CategoriesData();
    SubCategoriesData();
    // SizeData();
  }, []);

  return (
    <div className="al">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="al-head">
        <div>
          <h1 className="al-title">Product Detail Edit</h1>
          <p className="al-sub">Update this buyer product's specifications.</p>
        </div>
        <div className="al-head__actions">
          <button type="button" className="al-btn" onClick={() => Navigate(-1)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            Back
          </button>
        </div>
      </div>

      <div className="al-card">
        <div className="al-cardhead">
          <div className="al-cardhead__icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41 13.42 20.6a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" /><line x1="7" y1="7" x2="7.01" y2="7" /></svg></div>
          <h3 className="al-cardhead__title">Product Details</h3>
        </div>
            <form onSubmit={EditProduct.handleSubmit}>
              <div className="form-group">
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="al-label">
                      Product Name
                    </label>
                    <input
                      className="al-input"
                      type="text"
                      placeholder="Enter Product Name"
                      value={EditProduct.values.title}
                      onChange={EditProduct.handleChange}
                      onBlur={EditProduct.handleBlur}
                      name="title"
                      disabled
                    />
                    {EditProduct.errors.title && EditProduct.touched.title ? (
                      <h6 className="text-danger mt-2 ml-1">
                        {EditProduct.errors.title}
                      </h6>
                    ) : null}
                  </div>

                  <div className="col-md-6 mb-3">
                    <label
                      className="al-label"
                      style={{ display: "flex", justifyContent: "space-between" }}
                    >
                      Size
                      <span
                        style={{
                          cursor: "pointer",
                          marginLeft: "10px",
                          color: "blue",
                        }}
                        onClick={() => setShowSizeModal(true)}
                      >
                        ➕
                      </span>
                    </label>

                    <ReactSelect
                      isMulti
                      options={sizeData}
                      isClearable={false}
                      styles={colourStyles}
                      components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null,
                      }}
                      placeholder="Select Size"
                      name="size"
                      onChange={(selectedOptions) =>
                        EditProduct.setFieldValue(
                          "size",
                          selectedOptions?.map((option) => option.value) || []
                        )
                      }
                      value={
                        Array.isArray(EditProduct.values.size)
                          ? EditProduct.values.size.map((val) => ({
                              label: val,
                              value: val,
                            }))
                          : EditProduct.values.size
                          ? [
                              {
                                label: EditProduct.values.size,
                                value: EditProduct.values.size,
                              },
                            ]
                          : []
                      }
                    />
                    {EditProduct?.errors?.size &&
                      EditProduct?.touched?.size && (
                        <h6 className="text-danger mt-2 ml-1">
                          {EditProduct?.errors?.size}
                        </h6>
                      )}

                    {/* Modal Component */}
                    <SizeModal
                      show={showSizeModal}
                      onClose={() => setShowSizeModal(false)}
                      onAddSize={handleAddSize}
                    />
                  </div>

                  {/* <div className="col-md-6 mb-3">
                    <label className="al-label">
                      Size
                    </label>
                    <ReactSelect
                      isMulti
                      options={[
                        { label: "New Arrival", value: "new-arrival" },
                        { label: "Best Seller", value: "best-seller" },
                      ]}
                      isClearable={false}
                      styles={colourStyles}
                      components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null,
                      }}
                      placeholder="Select Size"
                      name="size"
                      // 👇 Important: Set array of selected values in Formik field
                      onChange={(selectedOptions) =>
                        EditProduct.setFieldValue(
                          "size",
                          selectedOptions?.map((option) => option.value) || []
                        )
                      }
                    />
                    {EditProduct?.errors?.size && EditProduct?.touched?.size && (
                      <h6 className="text-danger mt-2 ml-1">
                        {EditProduct?.errors?.size}
                      </h6>
                    )}
                  </div> */}

                  <div className="col-md-6 mb-3">
                    <label className="al-label">
                      Material Color
                    </label>
                    <ReactSelect
                      isMulti
                      options={[
                        { label: "White Duplex", value: "White Duplex" },
                        { label: "Brown Kraft", value: "Brown Kraft" },
                        { label: "Art Paper", value: "Art Paper" },
                      ]}
                      isClearable={false}
                      styles={colourStyles}
                      components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null,
                      }}
                      placeholder="Select Material Color"
                      name="material_color"
                      onChange={(selectedOptions) =>
                        EditProduct.setFieldValue(
                          "material_color",
                          selectedOptions?.map((option) => option.value) || []
                        )
                      }
                      // value={
                      //   Array.isArray(EditProduct.values.material_color)
                      //     ? EditProduct.values.material_color.map((val) => ({
                      //         label: val,
                      //         value: val,
                      //       }))
                      //     : []
                      // }

                      value={
                        Array.isArray(EditProduct.values.material_color)
                          ? EditProduct.values.material_color.map((val) => ({
                              label: val,
                              value: val,
                            }))
                          : EditProduct.values.material_color
                          ? [
                              {
                                label: EditProduct.values.material_color,
                                value: EditProduct.values.material_color,
                              },
                            ]
                          : []
                      }
                    />
                    {EditProduct?.errors?.material_color &&
                      EditProduct?.touched?.material_color && (
                        <h6 className="text-danger mt-2 ml-1">
                          {EditProduct?.errors?.material_color}
                        </h6>
                      )}
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="al-label">
                      Print Coverage
                    </label>
                    <ReactSelect
                      isMulti
                      options={[
                        { label: "Single", value: "Single" },
                        { label: "Multi", value: "Multi" },
                        { label: "No print", value: "No print" },
                      ]}
                      isClearable={false}
                      styles={colourStyles}
                      components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null,
                      }}
                      placeholder="Select Print Coverage"
                      name="print_coverage"
                      // ✅ Convert selected options to array of values
                      onChange={(selectedOptions) =>
                        EditProduct.setFieldValue(
                          "print_coverage",
                          selectedOptions?.map((option) => option.value) || []
                        )
                      }
                      // // ✅ Optional: for edit mode / default selected values
                      value={
                        Array.isArray(EditProduct.values.print_coverage)
                          ? EditProduct.values.print_coverage.map((val) => ({
                              label: val,
                              value: val,
                            }))
                          : EditProduct.values.print_coverage
                          ? [
                              {
                                label: EditProduct.values.print_coverage,
                                value: EditProduct.values.print_coverage,
                              },
                            ]
                          : []
                      }
                    />
                    {EditProduct?.errors?.print_coverage &&
                      EditProduct?.touched?.print_coverage && (
                        <h6 className="text-danger mt-2 ml-1">
                          {EditProduct?.errors?.print_coverage}
                        </h6>
                      )}
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="al-label">
                      Paper GSM
                    </label>
                    <ReactSelect
                      isMulti
                      options={[
                        { label: "100gsm", value: "100gsm" },
                        { label: "120gsm", value: "120gsm" },
                        { label: "150gsm", value: "150gsm" },
                        { label: "180gsm", value: "180gsm" },
                        { label: "220gsm", value: "220gsm" },
                        { label: "above", value: "above" },
                      ]}
                      isClearable={false}
                      styles={colourStyles}
                      components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null,
                      }}
                      placeholder="Select Paper GSM"
                      name="paper_gsm"
                      // ✅ Store selected values as array
                      onChange={(selectedOptions) =>
                        EditProduct.setFieldValue(
                          "paper_gsm",
                          selectedOptions?.map((option) => option.value) || []
                        )
                      }
                      // ✅ Show selected values correctly
                      value={
                        Array.isArray(EditProduct.values.paper_gsm)
                          ? EditProduct.values.paper_gsm.map((val) => ({
                              label: val,
                              value: val,
                            }))
                          : EditProduct.values.paper_gsm
                          ? [
                              {
                                label: EditProduct.values.paper_gsm,
                                value: EditProduct.values.paper_gsm,
                              },
                            ]
                          : []
                      }
                    />
                    {EditProduct?.errors?.paper_gsm &&
                      EditProduct?.touched?.paper_gsm && (
                        <h6 className="text-danger mt-2 ml-1">
                          {EditProduct?.errors?.paper_gsm}
                        </h6>
                      )}
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="al-label">
                      Burst Factor
                    </label>
                    <ReactSelect
                      isMulti
                      options={[
                        { label: "18", value: "18" },
                        { label: "20", value: "20" },
                        { label: "22", value: "22" },
                        { label: "24", value: "24" },
                        { label: "28", value: "28" },
                        { label: "35", value: "35" },
                        { label: "40", value: "40" },
                      ]}
                      isClearable={false}
                      styles={colourStyles}
                      components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null,
                      }}
                      placeholder="Select Burst Factor"
                      name="burst_factor"
                      // ✅ Convert selected options to values array for Formik
                      onChange={(selectedOptions) =>
                        EditProduct.setFieldValue(
                          "burst_factor",
                          selectedOptions?.map((option) => option.value) || []
                        )
                      }
                      // ✅ For showing selected values
                      value={
                        Array.isArray(EditProduct.values.burst_factor)
                          ? EditProduct.values.burst_factor.map((val) => ({
                              label: val,
                              value: val,
                            }))
                          : EditProduct.values.burst_factor
                          ? [
                              {
                                label: EditProduct.values.burst_factor,
                                value: EditProduct.values.burst_factor,
                              },
                            ]
                          : []
                      }
                    />
                    {EditProduct?.errors?.burst_factor &&
                      EditProduct?.touched?.burst_factor && (
                        <h6 className="text-danger mt-2 ml-1">
                          {EditProduct.errors.burst_factor}
                        </h6>
                      )}
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="al-label">
                      No Of Ply
                    </label>
                    <ReactSelect
                      isMulti
                      options={[
                        { label: "1Ply", value: "1Ply" },
                        { label: "2Ply", value: "2Ply" },
                        { label: "5Ply", value: "5Ply" },
                      ]}
                      isClearable={false}
                      styles={colourStyles}
                      components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null,
                      }}
                      placeholder="Select Ply"
                      name="no_of_ply"
                      // ✅ Store selected values array
                      onChange={(selectedOptions) =>
                        EditProduct.setFieldValue(
                          "no_of_ply",
                          selectedOptions?.map((option) => option.value) || []
                        )
                      }
                      // ✅ Optional: for edit mode or default value
                      value={
                        Array.isArray(EditProduct.values.no_of_ply)
                          ? EditProduct.values.no_of_ply.map((val) => ({
                              label: val,
                              value: val,
                            }))
                          : EditProduct.values.no_of_ply
                          ? [
                              {
                                label: EditProduct.values.no_of_ply,
                                value: EditProduct.values.no_of_ply,
                              },
                            ]
                          : []
                      }
                    />
                    {EditProduct?.errors?.no_of_ply &&
                      EditProduct?.touched?.no_of_ply && (
                        <h6 className="text-danger mt-2 ml-1">
                          {EditProduct.errors.no_of_ply}
                        </h6>
                      )}
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="al-label">
                      Category
                    </label>
                    <ReactSelect
                      options={categoryData}
                      isClearable={false}
                      styles={colourStyles}
                      components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null,
                      }}
                      placeholder="Select Category"
                      name="category"
                      onChange={(e) =>
                        EditProduct?.setFieldValue("category", e?.value)
                      }
                      value={
                        Array.isArray(EditProduct.values.category)
                          ? EditProduct.values.category.map((val) => ({
                              label: val,
                              value: val,
                            }))
                          : EditProduct.values.category
                          ? [
                              {
                                label: EditProduct.values.category,
                                value: EditProduct.values.category,
                              },
                            ]
                          : []
                      }
                    />

                    {EditProduct?.errors?.category &&
                      EditProduct?.touched?.category && (
                        <h6 className="text-danger mt-2 ml-1">
                          {EditProduct?.errors?.category}
                        </h6>
                      )}
                  </div>

                  {/* <div className="col-md-6 mb-3">
                    <label className="al-label">
                      Sub Category
                    </label>
                    <ReactSelect
                      options={subCategoryData}
                      isClearable={false}
                      styles={colourStyles}
                      components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null,
                      }}
                      placeholder="Select Sub Category"
                      name="sub_category"
                      onChange={(e) =>
                        EditProduct?.setFieldValue("sub_category", e?.value)
                      }
                      value={
                        subCategoryData.find(
                          (item) =>
                            item.value === EditProduct.values.sub_category
                        ) || null
                      }
                    />

                    {EditProduct?.errors?.sub_category &&
                      EditProduct?.touched?.sub_category && (
                        <h6 className="text-danger mt-2 ml-1">
                          {EditProduct?.errors?.sub_category}
                        </h6>
                      )}
                  </div> */}

                  <div className="col-md-6 mb-3">
                    <label className="al-label">
                      Lamination
                    </label>
                    <ReactSelect
                      // isMulti
                      options={[
                        { label: "Yes", value: "Yes" },
                        { label: "No", value: "No" },
                      ]}
                      isClearable={false}
                      styles={colourStyles}
                      components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null,
                      }}
                      placeholder="Select Lamination"
                      name="lamination"
                      onChange={(e) =>
                        EditProduct?.setFieldValue("lamination", e?.value)
                      }
                      value={
                        Array.isArray(EditProduct.values.lamination)
                          ? EditProduct.values.lamination.map((val) => ({
                              label: val,
                              value: val,
                            }))
                          : EditProduct.values.lamination
                          ? [
                              {
                                label: EditProduct.values.lamination,
                                value: EditProduct.values.lamination,
                              },
                            ]
                          : []
                      }
                    />
                    {EditProduct?.errors?.lamination &&
                      EditProduct?.touched?.lamination && (
                        <h6 className="text-danger mt-2 ml-1">
                          {EditProduct?.errors?.lamination}
                        </h6>
                      )}
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="al-label">
                      Quantity
                    </label>
                    <input
                      className="al-input"
                      type="text"
                      placeholder="Enter Quantity"
                      value={EditProduct.values.quantity}
                      onChange={EditProduct.handleChange}
                      onBlur={EditProduct.handleBlur}
                      name="quantity"
                    />
                  </div>
                  {EditProduct.errors.quantity &&
                  EditProduct.touched.quantity ? (
                    <h6 className="text-danger mt-2 ml-1">
                      {EditProduct.errors.quantity}
                    </h6>
                  ) : null}
                  <div className="col-md-6 mb-3">
                    <label className="al-label">
                      Product Image
                    </label>
                    <input
                      className="al-input al-input--file"
                      type="file"
                      accept="image/*"
                      onChange={(e) =>
                        EditProduct.setFieldValue(
                          "product_image",
                          e.currentTarget.files[0]
                        )
                      }
                      onBlur={EditProduct.handleBlur}
                      name="product_image"
                    />

                    {EditProduct.errors.product_image &&
                      EditProduct.touched.product_image && (
                        <h6 className="text-danger mt-2 ml-1">
                          {EditProduct.errors.product_image}
                        </h6>
                      )}

                    {/* ✅ Show preview if image exists */}
                    {EditProduct.values.product_image && (
                      <div className="mt-2">
                        {typeof EditProduct.values.product_image ===
                        "string" ? (
                          <img
                            src={`${process.env.REACT_APP_IMAGE_URL}/uploads/${EditProduct.values.product_image}`}
                            alt="Product Preview"
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "cover",
                              borderRadius: "8px",
                            }}
                          />
                        ) : (
                          <img
                            src={URL.createObjectURL(
                              EditProduct.values.product_image
                            )}
                            alt="New Upload Preview"
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "cover",
                              borderRadius: "8px",
                            }}
                          />
                        )}
                      </div>
                    )}
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="al-label">
                      Gallery Image
                    </label>
                    <input
                      className="al-input al-input--file"
                      type="file"
                      accept="image/*"
                      multiple
                      onChange={(e) =>
                        EditProduct.setFieldValue(
                          "gallery_image_path",
                          e.currentTarget.files
                        )
                      }
                      onBlur={EditProduct.handleBlur}
                      name="gallery_image_path"
                    />
                    {EditProduct.errors.gallery_image_path &&
                    EditProduct.touched.gallery_image_path ? (
                      <h6 className="text-danger mt-2 ml-1">
                        {EditProduct.errors.gallery_image_path}
                      </h6>
                    ) : null}
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="al-label">
                      Tags
                    </label>

                    <input
                      className="al-input"
                      type="text"
                      placeholder="Enter Tags (comma separated)"
                      value={EditProduct.values.product_tag.join(", ")}
                      onChange={(e) =>
                        EditProduct.setFieldValue(
                          "product_tag",
                          e.target.value.split(",").map((tag) => tag.trim())
                        )
                      }
                      onBlur={EditProduct.handleBlur}
                      name="product_tag"
                    />
                  </div>
                  {EditProduct.errors.product_tag &&
                  EditProduct.touched.product_tag ? (
                    <h6 className="text-danger mt-2 ml-1">
                      {EditProduct.errors.product_tag}
                    </h6>
                  ) : null}
                </div>

                <div
                  className="p-3 "
                  style={{
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #dee2e6",
                    borderRadius: "8px",
                  }}
                >
                  <label className="al-label">
                    Additional Fields
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary ml-2"
                      onClick={handleAddRow}
                    >
                      ➕
                    </button>
                  </label>

                  {extraFields.map((field, index) => (
                    <div className="row mb-2 align-items-center" key={index}>
                      <div className="col-md-5">
                        <input
                          type="text"
                          className="al-input"
                          placeholder="Enter Label"
                          value={field.label}
                          onChange={(e) =>
                            handleInputChange(index, "label", e.target.value)
                          }
                        />
                      </div>

                      <div className="col-md-5">
                        <input
                          type="text"
                          className="al-input"
                          placeholder="Enter Value"
                          value={field.inputValue}
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "inputValue",
                              e.target.value
                            )
                          }
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              handleAddValue(index);
                            }
                          }}
                        />
                      </div>

                      <div className="col-md-2 d-flex">
                        <button
                          type="button" // Important: Prevent it from behaving as submit
                          className="btn btn-primary"
                          style={{ marginRight: "10px" }}
                          onClick={(e) => handleAddValue(e, index)}
                        >
                          Add
                        </button>
                        <button
                          type="button"
                          className="btn btn-danger"
                          onClick={() => handleRemoveRow(index)}
                        >
                          Clear All
                        </button>
                      </div>

                      {/* Chips for current row */}
                      <div
                        className="col-md-12 d-flex align-items-center flex-wrap mt-3"
                        style={{ gap: "8px" }}
                      >
                        {field.values.map((val, valIndex) => (
                          <div
                            key={valIndex}
                            className="d-flex align-items-center px-2 py-1"
                            style={{
                              backgroundColor: "#d4edda",
                              color: "#155724",
                              fontWeight: "500",
                              fontSize: "0.75rem",
                              borderRadius: "20px",
                            }}
                          >
                            {val}
                            <button
                              type="button"
                              onClick={() => handleRemoveValue(index, valIndex)}
                              style={{
                                background: "transparent",
                                border: "none",
                                marginLeft: "6px",
                                fontWeight: "bold",
                                color: "#155724",
                                fontSize: "0.85rem",
                                cursor: "pointer",
                              }}
                            >
                              ×
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}

                  {/* <div
                    className="col-md-12 d-flex align-items-center overflow-auto mt-6"
                    style={{ gap: "8px", whiteSpace: "nowrap" }}
                  >
                    {values.map((val, index) => (
                      <div
                        key={index}
                        className="d-flex align-items-center px-2 py-1"
                        style={{
                          backgroundColor: "#d4edda",
                          color: "#155724",
                          fontWeight: "500",
                          fontSize: "0.75rem",
                          padding: "2px 8px",
                          borderRadius: "20px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {val}
                        <button
                          type="button"
                          onClick={() => handleRemove(index)}
                          style={{
                            border: "none",
                            background: "transparent",
                            marginLeft: "6px",
                            fontWeight: "bold",
                            color: "#155724",
                            fontSize: "0.85rem",
                            lineHeight: "1",
                            padding: 0,
                            cursor: "pointer",
                          }}
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div> */}
                </div>

                <div className="form-group">
                  <label className="al-label">
                    Specifications
                  </label>

                  <CKEditor
                    editor={ClassicEditor}
                    data={EditProduct.values.description} // Formik value
                    className="custom-ckeditor"
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      EditProduct.setFieldValue("description", data); // Formik method
                    }}
                    onBlur={() =>
                      EditProduct.setFieldTouched("description", true)
                    } // Mark as touched
                  />

                  {EditProduct.errors.description &&
                    EditProduct.touched.description && (
                      <h6 className="text-danger mt-2 ml-1">
                        {EditProduct.errors.description}
                      </h6>
                    )}
                </div>
              </div>
              <div className="al-actionbar">
                <button type="button" className="al-btn" onClick={() => Navigate(-1)}>Cancel</button>
                <button
                  type="submit"
                  className="al-btn al-btn--primary"
                  disabled={EditProduct.isSubmitting}
                >
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
                  Update Product
                </button>
              </div>
            </form>
      </div>
    </div>
  );
};

export default BuyerProductEdit;
